var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a, _b;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 *
 * Root.js
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 *
 * NOTE: while this component should technically be a stateless functional
 * component (SFC), hot reloading does not currently support SFCs. If hot
 * reloading is not a necessity for you then you can refactor it and remove
 * the linting exception.
 */
import React from 'react';
import { push } from 'connected-react-router';
import { Switch, Route } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import AppBuilderSubRouter from '../../app-builder/root';
import OrganizationLandingPage from '../OrganizationLandingPage/Loadable';
import LoginPage from '../LoginPage';
import PasswordResetPage from '../PasswordResetPage/Loadable';
import PartnerSignupFlows from '../PartnerSignupFlows/Loadable';
import PartnerCreateSignupFlowsPage from '../PartnerCreateSignupFlowsPage/Loadable';
import PartnerEditSignupFlowsPage from '../PartnerEditSignupFlowsPage/Loadable';
import GuidelinePage from '../GuidelinePage/Loadable';
import NewPasswordPage from '../NewPasswordPage/Loadable';
import AppUserNewPasswordPage from '../AppUserNewPasswordPage/Loadable';
import NotFoundPage from '../NotFoundPage/Loadable';
import InvalidOrg from '../InvalidOrg/Loadable';
import MissingConfiguration from '../MissingConfiguration/Loadable';
import Profile from '../ProfilePage/Loadable';
import OrgDashboardPage from '../OrgDashboardPage/Loadable';
import AppsPage from '../AppsPage/Loadable';
import GroupNew from '../GroupNew/Loadable';
import Permissions from '../Permission/Loadable';
import GroupDetails from '../GroupDetails/Loadable';
import Members from '../Members/Loadable';
import MemberInvite from '../MemberInvite/Loadable';
import Analytics from '../Analytics/Loadable';
import PartnerUsers from '../PartnerUsers/Loadable';
import System from '../System/Loadable';
import OrganizationSettings from '../OrganizationSettings/Loadable';
import EditOrganization from '../OrganizationEdit/Loadable';
import ProfilePreference, { ProfilePreferenceChangePassword, } from '../ProfilePreferencePage/Loadable';
import DataAndPrivacy, { DeleteAccount, RequestData, PrivacyPolicyList, } from '../DataAndPrivacy/Loadable';
import CreateOrganizationUser from '../CreateOrganizationUser/Loadable';
import ViewOrganization from '../ViewOrganization/Loadable';
import SignupPaymentPage from '../SignupPaymentPage/Loadable';
import SignupDevPlanPage from '../SignupDevPlanPage/Loadable';
import SignupPage from '../Signup/Loadable';
import Organizations from '../Organizations/Loadable';
import PartnerBundles from '../PartnerBundles/Loadable';
import PartnerDiscounts from '../PartnerDiscounts/Loadable';
import ResellersPage from '../ResellersPage/Loadable';
import ResellerDetailsPage from '../ResellerDetailsPage/Loadable';
import PartnerUpsertDiscountPage from '../PartnerUpsertDiscountPage/Loadable';
import PartnerDeveloperPlans from '../PartnerDeveloperPlans/Loadable';
import PartnerUpsertDeveloperPlanPage from '../PartnerUpsertDeveloperPlanPage/Loadable';
import PartnerUpsertBundlePage from '../PartnerUpsertBundlePage/Loadable';
import PartnerOrganizationPaymentsPage from '../PartnerOrganizationPayments/Loadable';
import PartnerPurchaseBundlePage from '../PartnerPurchaseBundlePage/Loadable';
import PartnerOrganizations from '../PartnerOrganizations/Loadable';
import PartnerPendingOrganizations from '../PartnerPendingOrganizations/Loadable';
import PartnerPendingOrganizationDetailsPage from '../PartnerPendingOrganizationDetailsPage/Loadable';
import CreateOrganizationPage from '../CreateOrganizationPage/Loadable';
import { InviteUserPage } from '../OrganizationDetailsPage/Loadable';
import CreateAdminRole from '../CreateAdminRole/Loadable';
import OrganizationRoles from '../OrganizationRoles/Loadable';
import OrganizationPayments from '../OrganizationPayments/Loadable';
import OrganizationPublicationBundles from '../OrganizationPublicationBundles/Loadable';
import OrganizationDeveloperPlans from '../OrganizationDeveloperPlans/Loadable';
import OrganizationAvailableDeveloperPlans from '../OrganizationDeveloperPlans/available';
import OrganizationDeveloperPlansUsage from '../OrganizationDeveloperPlans/usage';
import OrganizationDeveloperPlanAddons from '../OrganizationDeveloperPlans/addons';
import ResellerSelectedManagedOrgDevPlansPage from '../ResellerSelectedManagedOrgDevPlansPage/Loadable';
import ResellerSelectedManagedOrgAvailableDevPlansPage from '../ResellerSelectedManagedOrgDevPlansPage/available';
import ResellerSelectedManagedOrgDevPlansUsagePage from '../ResellerSelectedManagedOrgDevPlansPage/usage';
import ResellerSelectedManagedOrgDevPlansAddons from '../ResellerSelectedManagedOrgDevPlansPage/addons';
import PermissionDeniedPage from '../ErrorPages/403';
import InvalidPlatformVersionPage from '../ErrorPages/InvalidPlatformVersion';
import { makeSelectOrg, makeSelectUser, makeSelectInitialized, makeSelectLocation, makeSelectRole, makeSelectBarState, makeSelectMainSidebarState, makeSelectOrganizations, } from './selectors';
import { initializeData, acceptLatestTerm, acceptLatestPolicy, logout, secondarySideBarChange, mainSideBarChange, fetchPlatformVersion, setToken, removeToken, } from './actions';
import { checkOrgStatusSummery, resetOrgStatusSummery, } from '../../store/orgStatusSummery/actions';
import { AppContainer, PageWrapper, PageContent, RootContainer, } from './styles';
import { injectNavigation } from '../../utils/meta';
import ConditionsModal from '../../components/ConditionsModal';
import MainSideBarContainer from './SideNavBar/MainSideBarContainer';
import { DynamicPageWrapper } from '../../components/Page';
import { ModalRenderer } from '@project/components/ModalRenderer';
import MainNavBar from './MainNavBar';
import AnalyticsBar from './AnalyticsBar';
import SmallScreenWarning from './SmallScreenWarning';
import AppRedirectPage from './AppRedirectPage';
import OrgRedirectPage from './OrgRedirectPage';
import { getPermissionsByTargets } from '../../store/permissions/actions';
import AppBuilderMenu from '../../app-builder/root/layout/navigation';
import { makeSelectGlobalSearchApps } from '../../store/globalSearch/selectors';
var mapStateToProps = createStructuredSelector({
    role: makeSelectRole(),
    org: makeSelectOrg(),
    organizations: makeSelectOrganizations(),
    user: makeSelectUser(),
    apps: makeSelectGlobalSearchApps(),
    initialized: makeSelectInitialized(),
    location: makeSelectLocation(),
    barState: makeSelectBarState(),
    mainSidebarState: makeSelectMainSidebarState(),
});
var mapDispatchToProps = function (dispatch) { return ({
    onLoad: function (isLoggedIn, path, userId) {
        dispatch(initializeData(isLoggedIn, path, userId));
    },
    getOrgStatusSummery: function (organizationId) {
        dispatch(checkOrgStatusSummery(organizationId));
    },
    resetOrgStatus: function () {
        dispatch(resetOrgStatusSummery());
    },
    onSignout: function (path) {
        dispatch(logout(path));
    },
    goHome: function () {
        dispatch(push('/'));
    },
    goToValid: function (validUrl) {
        dispatch(push(validUrl));
    },
    onSideBarCollapse: function (menuState) {
        dispatch(secondarySideBarChange(menuState));
    },
    onMainSideBarCollapse: function (mainMenuState) {
        dispatch(mainSideBarChange(mainMenuState));
    },
    navigate: function (url) {
        dispatch(push(url));
    },
    getPlatformVersion: function () { return dispatch(fetchPlatformVersion()); },
    onAcceptLatestTerm: function (termId) { return dispatch(acceptLatestTerm(termId)); },
    onAcceptLatestPolicy: function (policyId) { return dispatch(acceptLatestPolicy(policyId)); },
    setToken: function (token) { return dispatch(setToken(token)); },
    removeToken: function () { return dispatch(removeToken()); },
    getPermissionsByTargets: function (targets) {
        return dispatch(getPermissionsByTargets(targets));
    },
}); };
var withConnect = connect(mapStateToProps, mapDispatchToProps);
var isSignup = (_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href) === null || _b === void 0 ? void 0 : _b.includes('/signup');
var Root = /** @class */ (function (_super) {
    __extends(Root, _super);
    function Root(props) {
        var _this = _super.call(this, props) || this;
        _this.tokenLogin = function () { return __awaiter(_this, void 0, void 0, function () {
            var existingToken, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, localStorage.getItem('token')];
                    case 1:
                        existingToken = _a.sent();
                        token = new URLSearchParams(this.props.location.search).get('token');
                        if (!existingToken) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.props.removeToken()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!token) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.props.setToken(token)];
                    case 4:
                        _a.sent();
                        this.props.onLoad(!!token, '', this.props.user.me.id);
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.handleCheckCard = function () {
            var _a, _b;
            var pathnameSplit = _this.props.location.pathname.split('/');
            if (((_a = _this.props.org) === null || _a === void 0 ? void 0 : _a.selectedOrganizationId) &&
                ((_b = _this.props.org) === null || _b === void 0 ? void 0 : _b.selectedOrganizationId) !== 'shared' &&
                pathnameSplit[1] === 'organizations' &&
                pathnameSplit.length > 2 /*checking only on org & app pages*/ &&
                _this.props.user.token) {
                _this.props.resetOrgStatus();
                _this.props.getOrgStatusSummery(_this.props.org.selectedOrganizationId);
            }
        };
        _this.retrieveAppPermissions = function (appId, orgId) {
            var targets = [];
            var AppBuilderMenuItems = AppBuilderMenu(appId, orgId).filter(function (menu) { return menu.id !== 3; });
            AppBuilderMenuItems.forEach(function (item) {
                if (item.target) {
                    targets.push(item.target);
                }
                if (item.children) {
                    item.children.forEach(function (child) {
                        if (child.data) {
                            child.data.forEach(function (innerChild) {
                                if (innerChild.target) {
                                    targets.push(innerChild.target);
                                }
                            });
                        }
                    });
                }
            });
            var getPermissionsByTargets = _this.props.getPermissionsByTargets;
            getPermissionsByTargets(targets);
        };
        _this.onAcceptTerm = function () {
            _this.props.onAcceptLatestTerm(_this.props.user.latestTerm.id);
        };
        _this.onDeclineTerm = function () {
            _this.props.onSignout('/terms/declined');
        };
        _this.onAcceptPolicy = function () {
            _this.props.onAcceptLatestPolicy(_this.props.user.latestPolicy.id);
            _this.setState({ tncVisible: true });
        };
        _this.onDeclinePolicy = function () {
            _this.props.onSignout('/privacy/declined');
        };
        _this.handleSecondaryMenuState = function (menuState) {
            _this.props.onSideBarCollapse(menuState);
        };
        _this.handleMainMenuState = function (mainMenuState) {
            _this.props.onMainSideBarCollapse(mainMenuState);
        };
        _this.goCardPaymentPage = function () {
            if (!_this.props.user.token &&
                window.location.href.includes('/payments') &&
                window.location.pathname) {
                _this.props.onSignout("/token/expired?".concat(window.location.pathname));
            }
        };
        _this.renderAuthorized = function () {
            var _a, _b;
            if (_this.props.location.pathname.includes('password-reset') ||
                _this.props.location.pathname.includes('resetpassword') ||
                _this.props.location.pathname.includes('accept-invitation')) {
                return null;
            }
            var _c = _this.props, org = _c.org, initialized = _c.initialized, navigate = _c.navigate, role = _c.role;
            var isSecondaryMenuVisible = _this.props.location.pathname.indexOf('partner') > -1 ||
                _this.props.location.pathname.indexOf('system') > -1 ||
                (_this.props.location.pathname.indexOf('organizations/') > -1 &&
                    !_this.props.location.pathname.includes('organizations/new') &&
                    !_this.props.location.pathname.includes('apps/new'));
            var _d = _this.props.barState, mainSideBar = _d.mainSideBar, secondarySideBar = _d.secondarySideBar;
            var organizationType = (_b = (_a = _this.props.organizations) === null || _a === void 0 ? void 0 : _a.find(function (org) { var _a; return org.id === ((_a = _this.props.org) === null || _a === void 0 ? void 0 : _a.selectedOrganizationId); })) === null || _b === void 0 ? void 0 : _b.type;
            var isSuperAdminPage = _this.props.location.pathname.indexOf('partner') > -1;
            return (_jsxs(React.Fragment, { children: [_this.props.user.token && (_jsx(Switch, { children: _jsx(Route, { path: "/", render: function (props) { return (_jsx(MainSideBarContainer, { location: _this.props.location, org: org, routeProps: props, role: role, navigate: navigate })); } }) })), organizationType &&
                        organizationType !== 'managed' &&
                        !isSuperAdminPage && _jsx(ModalRenderer, {}), _jsx(DynamicPageWrapper, __assign({ isSidebarOpen: _this.props.mainSidebarState.isOpen, isSidebarVisible: _this.props.mainSidebarState.isVisible, secondarySideBar: secondarySideBar, mainSideBar: mainSideBar, isSecondaryMenuVisible: isSecondaryMenuVisible }, { children: _jsxs(Switch, { children: [_jsx(Route, { exact: true, path: "/", component: OrgRedirectPage }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/dashboard", component: OrgDashboardPage }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/apps", component: AppsPage }), _jsx(Route, { exact: true, path: "/guideline", component: GuidelinePage }), _jsx(Route, { path: "/profile", component: Profile }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/members/invite", component: MemberInvite }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/roles/:groupId", component: GroupDetails }), _jsx(Route, { exact: true, path: "/groups/:groupId/create", component: CreateAdminRole }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/roles/:groupId/member/create", component: CreateAdminRole }), _jsx(Route, { exact: true, path: "/organizations", component: Organizations }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/roles", component: OrganizationRoles }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/members", component: Members }), _jsx(Route, { exact: true, path: "/organizations/new", component: CreateOrganizationPage }), _jsx(Route, { exact: true, path: "/organizations/:organizationId", component: OrganizationLandingPage }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/invite", component: InviteUserPage }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/permissions", render: function (props) { return (_jsx(Permissions, __assign({}, props, { type: "organization", baseUrl: "", crumbIter: 2 }))); } }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/payments", component: organizationType &&
                                        organizationType !== 'managed' &&
                                        OrganizationPayments }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/publicationBundles", component: organizationType &&
                                        organizationType !== 'managed' &&
                                        OrganizationPublicationBundles }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/settings", component: OrganizationSettings }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/edit", component: EditOrganization }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/members/new", component: CreateOrganizationUser }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/members/:userId", component: ViewOrganization }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/addRole", component: GroupNew }), _jsx(Route, { exact: true, path: "/groups/new", component: GroupNew }), _jsx(Route, { exact: true, path: "/groups/:groupId", component: GroupDetails }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/roles/:groupId/permissions", render: function (props) { return (_jsx(Permissions, __assign({}, props, { type: "group", level: "org", baseUrl: "/groups", crumbIter: 4 }))); } }), _jsx(Route, { exact: true, path: "/groups/:groupId/addmember", render: function (props) { return _jsx(Members, __assign({}, props, { add: true })); } }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/roles/:groupId/addmember", render: function (props) { return _jsx(Members, __assign({ level: "org" }, props, { add: true })); } }), _jsx(Route, { exact: true, path: "/groups/:groupId/requests", render: function (props) { return _jsx(Members, __assign({}, props, { requests: true })); } }), _jsx(Route, { path: "/partner/analytics", component: Analytics }), _jsx(Route, { path: "/partner/users", component: PartnerUsers }), _jsx(Route, { path: "/system", component: System }), _jsx(Route, { exact: true, path: "/partner/resellers", component: ResellersPage }), _jsx(Route, { exact: true, path: "/partner/resellers/:organizationId", component: ResellerDetailsPage }), _jsx(Route, { exact: true, path: "/partner/resellers/:resellerOrgId/managedOrg/:managedOrgId/developerPlans", component: ResellerSelectedManagedOrgDevPlansPage }), _jsx(Route, { exact: true, path: "/partner/resellers/:resellerOrgId/managedOrg/:managedOrgId/developerPlans/available", component: ResellerSelectedManagedOrgAvailableDevPlansPage }), _jsx(Route, { exact: true, path: "/partner/resellers/:resellerOrgId/managedOrg/:managedOrgId/developerPlans/usage", component: ResellerSelectedManagedOrgDevPlansUsagePage }), _jsx(Route, { exact: true, path: "/partner/resellers/:resellerOrgId/managedOrg/:managedOrgId/developerPlans/addons", component: ResellerSelectedManagedOrgDevPlansAddons }), _jsx(Route, { exact: true, path: "/partner/bundles/new", component: PartnerUpsertBundlePage }), _jsx(Route, { exact: true, path: "/partner/bundles/:bundleId/edit", component: PartnerUpsertBundlePage }), _jsx(Route, { exact: true, path: "/partner/bundles", component: PartnerBundles }), _jsx(Route, { exact: true, path: "/partner/discount", component: PartnerDiscounts }), _jsx(Route, { exact: true, path: "/partner/dev-plan", component: PartnerDeveloperPlans }), _jsx(Route, { exact: true, path: "/partner/signFlow", component: PartnerSignupFlows }), _jsx(Route, { exact: true, path: "/partner/signFlow/new", component: PartnerCreateSignupFlowsPage }), _jsx(Route, { exact: true, path: "/partner/signFlow/:signupFlowId/edit", component: PartnerEditSignupFlowsPage }), _jsx(Route, { exact: true, path: "/partner/discount/new", component: PartnerUpsertDiscountPage }), _jsx(Route, { exact: true, path: "/partner/dev-plan/new", component: PartnerUpsertDeveloperPlanPage }), _jsx(Route, { exact: true, path: "/partner/dev-plan/:devPlanId/edit", component: PartnerUpsertDeveloperPlanPage }), _jsx(Route, { exact: true, path: "/partner/discount/:discountId/edit", component: PartnerUpsertDiscountPage }), _jsx(Route, { exact: true, path: "/partner/organizations/:organizationId/payments", component: PartnerOrganizationPaymentsPage }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/developerPlans", component: organizationType && OrganizationDeveloperPlans }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/developerPlans/available", component: organizationType &&
                                        organizationType !== 'managed' &&
                                        OrganizationAvailableDeveloperPlans }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/developerPlans/usage", component: organizationType &&
                                        organizationType !== 'managed' &&
                                        OrganizationDeveloperPlansUsage }), _jsx(Route, { exact: true, path: "/organizations/:organizationId/developerPlans/addons", component: organizationType &&
                                        organizationType !== 'managed' &&
                                        OrganizationDeveloperPlanAddons }), _jsx(Route, { exact: true, path: "/partner/organizations/:organizationId/payments/new", component: PartnerPurchaseBundlePage }), _jsx(Route, { path: "/partner/organizations/active", component: PartnerOrganizations }), _jsx(Route, { path: "/partner/organizations/pending", component: PartnerPendingOrganizations }), _jsx(Route, { path: "/partner/organization/pending/:organizationId/edit", component: PartnerPendingOrganizationDetailsPage }), _jsx(Route, { exact: true, path: "/dataprivacy", component: DataAndPrivacy }), _jsx(Route, { exact: true, path: "/dataprivacy/deleteaccount", component: DeleteAccount }), _jsx(Route, { exact: true, path: "/dataprivacy/requestdata", component: RequestData }), _jsx(Route, { exact: true, path: "/dataprivacy/privacyList", component: PrivacyPolicyList }), _jsx(Route, { exact: true, path: "/preference", component: ProfilePreference }), _jsx(Route, { exact: true, path: "/preference/changepass", component: ProfilePreferenceChangePassword }), _jsx(Route, { exact: true, path: "/config", component: MissingConfiguration }), _jsx(Route, { exact: true, path: "/403", component: PermissionDeniedPage }), _jsx(Route, { exact: true, path: "/unsupported-app", component: InvalidPlatformVersionPage }), _jsx(Route, { exact: true, path: "/invalid-org", component: InvalidOrg }), _jsx(Route, { component: NotFoundPage })] }) })), _this.props.user.latestTerm && _this.state.tncVisible && (_jsx(ConditionsModal, { title: _this.props.user.latestTerm.name, description: "Updated on: ".concat(moment(_this.props.user.latestTerm.created_at).format('YYYY-MM-DD')), content: _this.props.user.latestTerm.description, open: !_this.props.user.latestTerm.accepted_at.Valid &&
                            _this.state.tncVisible, onAccept: _this.onAcceptTerm, onDecline: _this.onDeclineTerm })), _this.props.user.latestPolicy && (_jsx(ConditionsModal, { title: _this.props.user.latestPolicy.name, description: "Updated on: ".concat(moment(_this.props.user.latestPolicy.created_at).format('YYYY-MM-DD')), content: _this.props.user.latestPolicy.description, open: !_this.props.user.latestPolicy.accepted_at.Valid, onAccept: _this.onAcceptPolicy, onDecline: _this.onDeclinePolicy })), _jsx(ToastContainer, { enableMultiContainer: true, containerId: 'cms', position: "bottom-right", transition: Slide, autoClose: 4000, closeButton: false, closeOnClick: true, hideProgressBar: true })] }));
        };
        _this.state = {
            tncVisible: false,
        };
        return _this;
    }
    //COMPONENT MOUNT
    Root.prototype.componentDidMount = function () {
        if (this.props.location.pathname.includes('password-reset') ||
            this.props.location.pathname.includes('resetpassword') ||
            this.props.location.pathname.includes('accept-invitation') ||
            this.props.location.pathname.includes('signup')) {
            this.props.onSignout("".concat(this.props.location.pathname).concat(this.props.location.search));
            return;
        }
        if (this.props.location.search) {
            this.tokenLogin();
            return;
        }
        this.goCardPaymentPage();
        this.props.onLoad(!!this.props.user.token, this.props.location.pathname, this.props.user.me.id);
        injectNavigation(this.props.navigate);
        this.props.getPlatformVersion();
        this.handleCheckCard();
    };
    Root.prototype.getSnapshotBeforeUpdate = function (prevProps) {
        var _this = this;
        var prevAppIdSplit = prevProps.location.pathname.split('/');
        var prevAppId = prevAppIdSplit[3] === 'apps' ? prevAppIdSplit[4] : undefined;
        var appIdSplit = this.props.location.pathname.split('/');
        var appId = appIdSplit[3] === 'apps' ? appIdSplit[4] : undefined;
        var _a = this.props, onAppChanged = _a.onAppChanged, _b = _a.apps, apps = _b === void 0 ? [] : _b;
        if (prevAppId !== appId && appId !== undefined) {
            var app = apps === null || apps === void 0 ? void 0 : apps.find(function (a) { return a.id === appId; });
            var pv = (app === null || app === void 0 ? void 0 : app.platform_version) || null;
            if (pv &&
                typeof pv === 'object' &&
                'major' in pv &&
                'minor' in pv &&
                'patch' in pv) {
                pv = "".concat(pv === null || pv === void 0 ? void 0 : pv.major, ".").concat(pv === null || pv === void 0 ? void 0 : pv.minor, ".").concat(pv === null || pv === void 0 ? void 0 : pv.patch);
            }
            onAppChanged(pv, function () {
                return _this.retrieveAppPermissions(appId, prevAppIdSplit[2]);
            });
        }
        else if (appId === undefined) {
            onAppChanged();
        }
        return null;
    };
    //COMPONENT UPDATE
    Root.prototype.componentDidUpdate = function (prevProps) {
        var _a, _b, _c, _d, _e;
        // APPCUES updates
        var pathname = this.props.location.pathname;
        var previousLocation = prevProps.location.pathname;
        if (pathname !== previousLocation) {
            if ((window === null || window === void 0 ? void 0 : window.Appcues) && typeof (window === null || window === void 0 ? void 0 : window.Appcues.page) === 'function') {
                window.Appcues.page();
            }
            if ((window === null || window === void 0 ? void 0 : window.Appcues) && typeof (window === null || window === void 0 ? void 0 : window.Appcues.identify) === 'function') {
                var me = this.props.user.me;
                if (me.id) {
                    window.Appcues.identify(me.id, __assign(__assign({}, me), { lastName: (_a = me === null || me === void 0 ? void 0 : me.meta) === null || _a === void 0 ? void 0 : _a.last_name }));
                }
            }
        }
        // ***************
        if (this.props.location.pathname.includes('password-reset') ||
            this.props.location.pathname.includes('resetpassword') ||
            this.props.location.pathname.includes('accept-invitation')) {
            return;
        }
        (((_b = prevProps.org) === null || _b === void 0 ? void 0 : _b.selectedOrganizationId) !==
            ((_c = this.props.org) === null || _c === void 0 ? void 0 : _c.selectedOrganizationId) ||
            ((_d = prevProps.organizations) === null || _d === void 0 ? void 0 : _d.length) !== ((_e = this.props.organizations) === null || _e === void 0 ? void 0 : _e.length)) &&
            this.handleCheckCard();
        if (!this.props.authentication_request && this.props.authentication_error) {
            this.props.goHome();
        }
        if (this.props.user.token !== prevProps.user.token) {
            this.props.getPlatformVersion();
        }
        if (location === '/' || previousLocation !== location) {
            if (pathname !== '/' && pathname.endsWith('/')) {
                this.props.goToValid(pathname.slice(0, -1));
            }
        }
    };
    Root.prototype.renderUnauthorized = function () {
        var _this = this;
        return (_jsxs(PageWrapper, { children: [_jsx(PageContent, __assign({ className: !isSignup && 'overflow-hidden' }, { children: _jsxs(Switch, { children: [_jsx(Route, { exact: true, path: [
                                    '/',
                                    '/terms/declined',
                                    '/privacy/declined',
                                    '/token/expired',
                                    '/token/not-found',
                                ], component: LoginPage }), _jsx(Route, { path: "/guideline", component: GuidelinePage }), _jsx(Route, { path: "/password-reset", component: PasswordResetPage }), _jsx(Route, { path: "/resetpassword", component: NewPasswordPage }), _jsx(Route, { path: "/accept-invitation", component: AppUserNewPasswordPage }), _jsx(Route, { exact: true, path: "/403", component: PermissionDeniedPage }), _jsx(Route, { exact: true, path: "/unsupported-app", component: InvalidPlatformVersionPage }), _jsx(Route, { exact: true, path: "/signup", component: SignupPage }), _jsx(Route, { exact: true, path: "/signup/plan", component: SignupDevPlanPage }), _jsx(Route, { exact: true, path: "/signup/payment", component: SignupPaymentPage }), _jsx(Route, { render: function () { return (_jsx(Redirect, { to: "/token/not-found?".concat(_this.props.location.pathname) })); } })] }) })), _jsx(ToastContainer, { enableMultiContainer: true, containerId: 'cms', position: "bottom-right", transition: Slide, autoClose: 4000, closeButton: false, closeOnClick: true, hideProgressBar: true })] }));
    };
    Root.prototype.render = function () {
        var pathArray = this.props.location.pathname.split('/');
        return (_jsx(RootContainer, { children: this.props.user.token &&
                !window.location.href.includes('/signup') &&
                pathArray[3] === 'apps' &&
                pathArray[4] !== 'new' &&
                pathArray.length > 4 ? (_jsxs(_Fragment, { children: [_jsx(Switch, { children: _jsx(Route, { path: "/organizations/:organizationId/apps/:appId", component: SmallScreenWarning }) }), _jsx(Switch, { children: _jsx(Route, { path: "/organizations/:organizationId/apps/:appId", render: function () { return _jsx(AppBuilderSubRouter, {}); } }) })] })) : this.props.user.token &&
                !window.location.href.includes('/signup') &&
                pathArray[1] === 'apps' ? (_jsx(Switch, { children: _jsx(Route, { path: "/apps", component: AppRedirectPage }) })) : (_jsxs(_Fragment, { children: [_jsx(Switch, { children: _jsx(Route, { path: [
                                '/token/expired',
                                '/terms/declined',
                                '/privacy/declined',
                                '/apps/:appId([0-9]+)',
                                '/apps',
                                '/organizations/:organizationId',
                                '/organizations',
                                '/analytics',
                                '/partner',
                                '/preference',
                                '/dataprivacy',
                            ], component: SmallScreenWarning }) }), _jsx(Switch, { children: _jsx(Route, { path: [
                                '/organizations/:organizationId',
                                '/organizations',
                                '/analytics',
                                '/partner',
                                '/preference',
                                '/dataprivacy',
                                '/',
                            ], component: MainNavBar }) }), _jsx(AppContainer, { children: this.props.user.token &&
                            !window.location.href.includes('/signup')
                            ? this.renderAuthorized()
                            : this.renderUnauthorized() }), _jsx(AnalyticsBar, { locationPath: this.props.location.pathname })] })) }));
    };
    return Root;
}(React.Component));
export { Root };
export default withConnect(Root);
